module.exports = __webpack_public_path__ + "static/media/gas.ea55fb2e.png";